import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from '../Page/Navbar';
import Footer from '../Page/Footer';
import PageHeader from '../Page/PageHeader';
import './BlogIndex.css';

const BlogIndex = () => {
  // Categories of articles
  const categories = [
    {
      id: 'astrologie',
      title: 'Astrologie',
      description: "Articles généraux pour comprendre l'astrologie au-delà des clichés",
      articles: [
        {
          title: "Quel est le signe le plus difficile ?",
          url: '/blog/astrologie/signe-le-plus-difficile',
          image: '/images/blog/phases_de_la_lune.webp',
          description: "Nuances et vérités: existe-t-il vraiment un 'pire' signe ?"
        },
        {
          title: "Quel est le signe astrologique le plus intelligent ?",
          url: '/blog/astrologie/signe-le-plus-intelligent',
          image: '/images/blog/phases_de_la_lune.webp',
          description: "Intelligence: logique, émotionnelle, créative... qui brille où ?"
        }
      ]
    },
    {
      id: 'planets',
      title: 'Planètes en Astrologie',
      description: "Découvrez l'influence de chaque planète sur votre thème astral",
      articles: [
        {
          title: 'La Lune en Astrologie',
          url: '/blog/planetes/lune',
          image: '/images/planetes/lune.webp',
          description: "L'influence émotionnelle et instinctive de la Lune"
        },
        {
          title: 'Le Soleil en Astrologie',
          url: '/blog/planetes/soleil',
          image: '/images/planetes/soleil.webp',
          description: "L'essence de notre identité et notre vitalité"
        },
        {
          title: 'Mercure en Astrologie',
          url: '/blog/planetes/mercure',
          image: '/images/planetes/mercure.webp',
          description: "La planète de la communication et de l'intellect"
        },
        {
          title: 'Vénus en Astrologie',
          url: '/blog/planetes/venus',
          image: '/images/planetes/venus.webp',
          description: "La planète de l'amour et des valeurs"
        },
        {
          title: 'Mars en Astrologie',
          url: '/blog/planetes/mars',
          image: '/images/planetes/mars.webp',
          description: "La planète de l'action et de la motivation"
        },
        {
          title: 'Jupiter en Astrologie',
          url: '/blog/planetes/jupiter',
          image: '/images/planetes/jupiter.webp',
          description: "La planète de l'expansion et de la chance"
        },
        {
          title: 'Saturne en Astrologie',
          url: '/blog/planetes/saturne',
          image: '/images/planetes/saturne.webp',
          description: "La planète des limites et de la structure"
        },
        {
          title: 'Uranus en Astrologie',
          url: '/blog/planetes/uranus',
          image: '/images/planetes/uranus.webp',
          description: "La planète du changement et de l'innovation"
        },
        {
          title: 'Neptune en Astrologie',
          url: '/blog/planetes/neptune',
          image: '/images/planetes/neptune.webp',
          description: "La planète de l'inspiration et de l'illusion"
        },
        {
          title: 'Pluton en Astrologie',
          url: '/blog/planetes/pluton',
          image: '/images/planetes/pluton.webp',
          description: "La planète de la transformation et du pouvoir"
        }
      ]
    },
    {
      id: 'zodiac',
      title: 'Signes du Zodiaque',
      description: 'Tout savoir sur les 12 signes astrologiques',
      articles: [
        {
          title: 'Bélier : Le Signe du Pionnier',
          url: '/blog/signes/belier',
          image: '/images/signes/belier.webp',
          description: 'Le signe du Bélier et ses caractéristiques'
        },
        {
          title: 'Taureau : Le Signe du Bâtisseur',
          url: '/blog/signes/taureau',
          image: '/images/signes/taureau.webp',
          description: 'Le signe du Taureau et ses caractéristiques'
        },
        {
          title: 'Gémeaux : Le Signe du Messager',
          url: '/blog/signes/gemeaux',
          image: '/images/signes/gemeaux.webp',
          description: 'Le signe des Gémeaux et ses caractéristiques'
        },
        {
          title: 'Cancer : Le Signe du Protecteur',
          url: '/blog/signes/cancer',
          image: '/images/signes/cancer.webp',
          description: 'Le signe du Cancer et ses caractéristiques'
        },
        {
          title: 'Lion : Le Signe du Roi',
          url: '/blog/signes/lion',
          image: '/images/signes/lion.webp',
          description: 'Le signe du Lion et ses caractéristiques'
        },
        {
          title: 'Vierge : Le Signe de l\'Analyste',
          url: '/blog/signes/vierge',
          image: '/images/signes/vierge.webp',
          description: 'Le signe de la Vierge et ses caractéristiques'
        },
        {
          title: 'Balance : Le Signe du Diplomate',
          url: '/blog/signes/balance',
          image: '/images/signes/balance.webp',
          description: 'Le signe de la Balance et ses caractéristiques'
        },
        {
          title: 'Scorpion : Le Signe du Transformateur',
          url: '/blog/signes/scorpion',
          image: '/images/signes/scorpion.webp',
          description: 'Le signe du Scorpion et ses caractéristiques'
        },
        {
          title: 'Sagittaire : Le Signe de l\'Explorateur',
          url: '/blog/signes/sagittaire',
          image: '/images/signes/sagittaire.webp',
          description: 'Le signe du Sagittaire et ses caractéristiques'
        },
        {
          title: 'Capricorne : Le Signe du Bâtisseur',
          url: '/blog/signes/capricorne',
          image: '/images/signes/capricorne.webp',
          description: 'Le signe du Capricorne et ses caractéristiques'
        },
        {
          title: 'Verseau : Le Signe du Visionnaire',
          url: '/blog/signes/verseau',
          image: '/images/signes/verseau.webp',
          description: 'Le signe du Verseau et ses caractéristiques'
        },
        {
          title: 'Poissons : Le Signe du Mystique',
          url: '/blog/signes/poissons',
          image: '/images/signes/poissons.webp',
          description: 'Le signe des Poissons et ses caractéristiques'
        }
      ]
    },
    {
      id: 'maisons',
      title: 'Maisons Astrologiques',
      description: 'Explorez les 12 maisons astrologiques et leurs significations dans votre thème natal',
      articles: [
        {
          title: 'Maison 1 : L\'Ascendant et la Personnalité',
          url: '/blog/maisons/maison-1',
          image: '/images/maisons/maison1.png',
          description: 'Découvrez votre Ascendant et votre identité sociale'
        },
        {
          title: 'Maison 2 : L\'Argent et les Ressources',
          url: '/blog/maisons/maison-2',
          image: '/images/maisons/maison2.png',
          description: 'Votre rapport à l\'argent, vos valeurs et vos talents naturels'
        },
        {
          title: 'Maison 3 : Communication et Entourage',
          url: '/blog/maisons/maison-3',
          image: '/images/maisons/maison3.png',
          description: 'Votre style de communication et vos relations de proximité'
        },
        {
          title: 'Maison 4 : Racines et Foyer',
          url: '/blog/maisons/maison-4',
          image: '/images/maisons/maison4.png',
          description: 'Votre rapport à la famille, au foyer et à la sécurité émotionnelle'
        },
        {
          title: 'Maison 5 : Créativité et Expression',
          url: '/blog/maisons/maison-5',
          image: '/images/maisons/maison5.png',
          description: 'Votre créativité, vos loisirs, vos amours et votre expression personnelle'
        },
        {
          title: 'Maison 6 : Travail et Santé',
          url: '/blog/maisons/maison-6',
          image: '/images/maisons/maison6.png',  
          description: 'Votre travail quotidien, votre santé et votre sens du service'
        },
        {
          title: 'Maison 7 : Relations et Partenariats',
          url: '/blog/maisons/maison-7',
          image: '/images/maisons/maison7.png',
          description: 'Vos relations amoureuses, partenariats et votre style relationnel'
        },
        {
          title: 'Maison 8 : Transformations et Renaissances',
          url: '/blog/maisons/maison-8',
          image: '/images/maisons/maison8.png',
          description: 'Vos transformations profondes, votre intimité et vos héritages'
        },
        {
          title: 'Maison 9 : Philosophie et Expansion',
          url: '/blog/maisons/maison-9',
          image: '/images/maisons/maison9.png',
          description: 'Votre quête de sens, vos voyages et votre expansion de conscience'
        },
        {
          title: 'Maison 10 : Carrière et Ambition',
          url: '/blog/maisons/maison-10',
          image: '/images/maisons/maison10.png',
          description: 'Votre carrière, votre ambition et votre place dans le monde'
        },
        {
          title: 'Maison 11 : Amitiés et Engagement',
          url: '/blog/maisons/maison-11',
          image: '/images/maisons/maison11.png',
          description: 'Vos amitiés, vos rêves d\'avenir et votre engagement collectif'
        },
        {
          title: 'Maison 12 : ton Monde Intérieur, tes Épreuves et ton Chemin Spirituel',
          url: '/blog/maisons/maison-12',
          image: '/images/maisons/maison12.png',
          description: 'Explore les mystères de la Maison 12 : ton inconscient, tes épreuves transformatrices et ta spiritualité profonde.'
        },
      ]
    },
    // Other categories would be listed here
  ];

  return (
    <>
      <Navbar />
      <div className="blog-index-container">
        <Helmet>
          <title>Blog Astrologique | AstraLight</title>
          <meta name="description" content="Explorez notre blog sur l'astrologie, les planètes, les signes du zodiaque et plus encore." />
        </Helmet>

        <PageHeader
          eyebrow="Apprendre l'astrologie"
          title="Blog astrologique"
          subtitle="Planètes, signes du zodiaque, maisons : tout ce qu'il faut pour comprendre votre thème astral et votre synastrie en profondeur."
        >
          <span className="page-header-chip">
            <i className="fa-solid fa-book-open" aria-hidden="true"></i>
            {categories.reduce((n, c) => n + c.articles.length, 0)} articles gratuits
          </span>
        </PageHeader>

        <main className="blog-index-content">
          {categories.map((category) => (
            <section key={category.id} className="blog-category">
              <h2 className="blog-category-title">{category.title}</h2>
              <p className="blog-category-description">{category.description}</p>
              
              <div className="blog-articles-grid">
                {category.articles.map((article, index) => (
                  <Link to={article.url} key={index} className="blog-article-card">
                    <div className="blog-article-image">
                      <img src={article.image} alt={article.title} />
                    </div>
                    <div className="blog-article-info">
                      <h3 className="blog-article-title">{article.title}</h3>
                      <p className="blog-article-excerpt">{article.description}</p>
                      <span className="blog-read-more">Lire l'article</span>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </main>
      </div>

      <Footer />
    </>
  );
};

export default BlogIndex; 